"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CATALOGUE_PRIORITY_ORDER_QUOTA_CONSERVATIVE = exports.CATALOGUE_PRIORITY_ORDER = exports.CatalogueItemMetadataSchema = exports.CatalogueItemSchema = exports.CatalogueMatchKindSchema = exports.CatalogueMatchKind = exports.CatalogueNameSchema = exports.CatalogueName = void 0;
exports.getPrimaryCatalogueItem = getPrimaryCatalogueItem;
exports.pickPrimaryCatalogueName = pickPrimaryCatalogueName;
const zod_1 = require("zod");
var CatalogueName;
(function (CatalogueName) {
    CatalogueName["Digikey"] = "digikey";
    CatalogueName["Octopart"] = "octopart";
    CatalogueName["UltraLibrarian"] = "ultralibrarian";
    CatalogueName["ParentDeployment"] = "parent_deployment";
})(CatalogueName || (exports.CatalogueName = CatalogueName = {}));
exports.CatalogueNameSchema = zod_1.z.nativeEnum(CatalogueName);
var CatalogueMatchKind;
(function (CatalogueMatchKind) {
    CatalogueMatchKind["Exact"] = "exact";
    CatalogueMatchKind["BasePartSuffix"] = "base_part_suffix";
})(CatalogueMatchKind || (exports.CatalogueMatchKind = CatalogueMatchKind = {}));
exports.CatalogueMatchKindSchema = zod_1.z.nativeEnum(CatalogueMatchKind);
exports.CatalogueItemSchema = zod_1.z.object({
    catalogueName: exports.CatalogueNameSchema,
    mpn: zod_1.z.string(),
    catalogueManufacturerName: zod_1.z.string().optional(),
    cataloguePackageFamilyName: zod_1.z.string().optional(),
    datasheetUrl: zod_1.z.string().optional(),
    catalogueProductUrl: zod_1.z.string().optional(),
    productImageUrl: zod_1.z.string().optional(),
    description: zod_1.z.string(),
    catalogueIds: zod_1.z.array(zod_1.z.string()),
    parameters: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    rawMetadata: zod_1.z.unknown().optional(),
    matchKind: exports.CatalogueMatchKindSchema.optional(),
});
exports.CatalogueItemMetadataSchema = zod_1.z.object({
    catalogueIds: zod_1.z.array(zod_1.z.string()),
    parameters: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    rawMetadata: zod_1.z.unknown().optional(),
});
exports.CATALOGUE_PRIORITY_ORDER = [
    CatalogueName.Digikey,
    CatalogueName.Octopart,
    CatalogueName.UltraLibrarian,
];
exports.CATALOGUE_PRIORITY_ORDER_QUOTA_CONSERVATIVE = [
    CatalogueName.Octopart,
    CatalogueName.Digikey,
    CatalogueName.UltraLibrarian,
];
function getPrimaryCatalogueItem(catalogueItems) {
    if (!catalogueItems || catalogueItems.length === 0) {
        return null;
    }
    const distributorItems = catalogueItems.filter((item) => item.catalogueName !== CatalogueName.ParentDeployment);
    const pool = distributorItems.length > 0 ? distributorItems : catalogueItems;
    const exactItems = pool.filter((item) => item.matchKind !== CatalogueMatchKind.BasePartSuffix);
    const candidates = exactItems.length > 0 ? exactItems : pool;
    for (const catalogueName of exports.CATALOGUE_PRIORITY_ORDER) {
        const item = candidates.find((item) => item.catalogueName === catalogueName);
        if (item) {
            return item;
        }
    }
    return candidates[0];
}
function pickPrimaryCatalogueName(catalogues) {
    if (!catalogues || catalogues.length === 0) {
        return null;
    }
    for (const name of exports.CATALOGUE_PRIORITY_ORDER) {
        if (catalogues.includes(name)) {
            return name;
        }
    }
    return catalogues[0];
}
//# sourceMappingURL=catalogue-item.js.map